import React from 'react';
import { Check } from 'lucide-react';

const items = {
  en: [
    'Functional training for strength, mobility and coordination',
    'Daily mindfulness and breathing exercises for mental strength',
    'Stress reduction through targeted recovery routines',
    'Long-term health instead of short-term diets',
  ],
  de: [
    'Funktionelles Training für Kraft, Beweglichkeit und Koordination',
    'Tägliche Achtsamkeits- und Atemübungen für mentale Stärke',
    'Stressreduktion durch gezielte Erholungsroutinen',
    'Langfristige Gesundheit statt kurzfristiger Diäten',
  ],
};

export default function TrainingGoals({ lang }) {
  const t = {
    headline: lang === 'de' ? 'GANZHEITLICHES WOHLBEFINDEN — NACHHALTIG UND AUSGEWOGEN' : 'HOLISTIC WELLBEING — SUSTAINABLE AND BALANCED',
    sub:
      lang === 'de'
        ? 'Alles was du brauchst, um deine Fitnessziele zu erreichen – einfach, effektiv, nachhaltig.'
        : 'Everything you need to reach your fitness goals — simple, effective, sustainable.',
  };

  return (
    <section className="bg-slate-50 py-20 lg:py-28">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Headline */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 text-xs font-bold uppercase tracking-widest rounded-full mb-4">
            {lang === 'de' ? 'Dein Weg' : 'Your Path'}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight">
            {t.headline}
          </h2>
          <p className="mt-4 text-lg text-slate-500 max-w-xl mx-auto">{t.sub}</p>
        </div>

        {/* Check items grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {items[lang].map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-white rounded-2xl px-6 py-5 shadow-sm border border-slate-100 hover:shadow-md hover:border-emerald-100 transition-all duration-300"
            >
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-600 flex items-center justify-center mt-0.5">
                <Check size={16} color="white" strokeWidth={3} />
              </div>
              <p className="text-slate-700 font-medium text-base leading-snug">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
